module.exports = __webpack_public_path__ + "img/bo.c83fd44.svg";